module.exports = __webpack_public_path__ + "static/img/MG.09fb285a.png";